import {createSlice, PayloadAction} from "@reduxjs/toolkit";

type State = {
  selected: boolean,
  record: any
};

const initialState: State = {
  selected: false,
  record: null
};

export const patientRecordSlice = createSlice({
  name: "patientRecord",
  initialState: initialState,
  reducers: {
    setPatientRecord: (state = initialState, action: PayloadAction<any>) => {
      return {
        ...state,
        selected: action.payload.selected,
        record: action.payload.record
      }
    },
  },
});

export const {setPatientRecord} = patientRecordSlice.actions;

export default patientRecordSlice.reducer;
